export default __webpack_public_path__ + "static/project-slide-6-992-765-57731e7c3743f6a78a07faa5feb804c6.jpg";